/**
 * Route for `favicon`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FaviconPage } from "../features/favicon/FaviconPage";

export const faviconRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/favicon",
	component: FaviconPage,
});

export default faviconRoute;
